import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import repAPI from '../../sources/api/repAPI';

// constants
import { BLOCK_REP } from '../../constants/repTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { repSchema } from '../../schemas/Normalizr';
import { toastr } from 'react-redux-toastr';
import { BLOCK_REP_SUCCESS, BLOCK_REP_ERROR } from '../../constants/messages';

export function* searchRep(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(BLOCK_REP, call(repAPI.block, params), repSchema);
    yield toastr.success('Success', BLOCK_REP_SUCCESS);
  } catch (e) {
    yield toastr.error(BLOCK_REP_ERROR);
    yield put(error(BLOCK_REP, e));
  } finally {
    yield put(doneIndicator(BLOCK_REP));
  }
}

export function* watchSearchRep() {
  yield takeEvery(BLOCK_REP, searchRep);
}

export default function* root() {
  yield all([
    fork(watchSearchRep)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/rep/blockRep.js